
export const sFechaPublicacion = '2026-09-27T21:45:54.9867884-06:00';
export const sVersion = 'vf1.1.609272145';
            